import { PlanFeature } from '@anm/api/modules/pricing';
import { SubscriptionFeature } from '@anm/api/modules/subscription';
import { PlanFeatureProps } from '@anm/components/pricing/PlanFeature';
import template from '@anm/helpers/string/template';
import get from 'lodash/fp/get';

export default (
  planFeature: PlanFeature,
  subscriptionFeature: SubscriptionFeature
): PlanFeatureProps => {
  const getValueByPath = (key: string) => get(key)(subscriptionFeature);
  const content = template(planFeature.content)(getValueByPath);

  return {
    ...planFeature,
    content
  };
};
